import React from 'react';
import Head from 'next/head';

import { getBlogContent } from '@api/blog/getBlogContent';
import { withLayoutAndSession } from '@utils/hocs';
import { PageWithProvidersAndLayout } from '@utils/types/nextApp';
import { BlogContentType } from '@utils/types/blog';
import FeaturedBlog from '@components/blog/featuredBlog';
import BlogList from '@components/blog/blogList';
import BlogCategory from '@components/blog/blogCategory';

import styles from './styles.module.scss';

type Props = {
  data: BlogContentType;
};

type StaticProps = {
  props: Props;
  revalidate: Number;
};

const Blog: PageWithProvidersAndLayout<Props> = (props: Props) => {
  const {
    data: { categories, featuredBlog, latestNotFeaturedBlogs },
  } = props;

  return (
    <>
      <Head>
        <title>Blog</title>
      </Head>
      <h1 style={{ display: 'none' }}>Blog</h1>

      {featuredBlog[0] && <FeaturedBlog featuredBlog={featuredBlog[0]} />}

      <div className={styles.blogPageContent}>
        <BlogList
          blogs={latestNotFeaturedBlogs}
          containerStyle={styles.latestBlogs}
        />

        {categories.map((category) => (
          <BlogCategory category={category} key={category._id} />
        ))}
      </div>
    </>
  );
};

export async function getStaticProps(): Promise<StaticProps | undefined> {
  try {
    const data = await getBlogContent();
    return {
      props: { data },
      revalidate: 30,
    };
  } catch (error) {
    console.error(error);
  }
}

export default withLayoutAndSession(Blog, {
  headerProps: { theme: 'light' },
  footerProps: { theme: 'light' },
});
